module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form_row"
  }, [_c('div', {
    staticClass: "item left",
    domProps: {
      "innerHTML": _vm._s(_vm.$options.filters.capitalize(_vm.translateMessage(_vm.placeholder)))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "select_right",
    class: {
      'has-success': _vm.success && _vm.isRequired, 'has-error': !_vm.success && _vm.isRequired
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newValue),
      expression: "newValue"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "70%"
    },
    attrs: {
      "disabled": _vm.isDisabled,
      "rows": "4",
      "type": "text",
      "placeholder": _vm.$options.filters.capitalize(_vm.translateMessage(_vm.placeholder))
    },
    domProps: {
      "value": (_vm.newValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newValue = $event.target.value
      }
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8d4f3c10","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/form/Textarea.vue
// module id = 57
// module chunks = 0